import React from "react";
import { Box, Grid } from "@mui/material";
import { AppLayout } from "layout";
import {

  MyContentData,
} from "modules/MyContent/components";
import { ContentsData } from "modules/Contents/components";

type Props = {};

const ContentsContainer = (props: Props) => {

  return (
    <AppLayout>
      <ContentsData />
    </AppLayout>
  );
};

export default ContentsContainer;
